import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { FaSearch } from "react-icons/fa";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import { formatDistanceToNow } from "date-fns";

import { loadUnassignedTickets } from "../../redux/tasks/ticketsT";
import TopBar from "../../components/TopBar";
import Sidebar from "../../components/Sidebar";
import Spinner from "../../components/Spinner";
import Table from "../../components/Table";

const TableColumns = [
  {
    Header: "#",
    accessor: "ticketNo",
  },
  {
    Header: "Subject",
    accessor: "subject",
  },
  {
    Header: "Status",
    accessor: "status",
    Cell: ({ value }) => {
      return value === "RESOLVED"
        ? "Resolved"
        : value === "MARKEDASRESOLVED"
        ? "Marked as Resolved"
        : value === "WORKINPROGRESS"
        ? "Work in Progress"
        : "Un-Assigned";
    },
  },
  {
    Header: "Priority",
    accessor: "priority",
    Cell: ({ value }) => {
      let textColor = "blue";

      switch (value?.toLowerCase()) {
        case "high":
          textColor = "#ef4444"; // red-500
          break;
        case "medium":
          textColor = "#f59e0b"; // amber-500
          break;
        case "low":
          textColor = "#10b981"; // green-500
          break;
        default:
          textColor = "black";
      }

      return (
        <span
          style={{
            color: textColor,
            // padding: "4px 8px",
            // borderRadius: "12px",
            // textTransform: "capitalize",
            fontWeight: 700,
          }}
        >
          {value || "N/A"}
        </span>
      );
    },
  },
  {
    Header: "Created at",
    accessor: "createdAt",
    Cell: ({ value }) => {
      // return format(new Date(value), "MM-dd-yyyy");
      if (!value) return "N/A";
      const age = formatDistanceToNow(new Date(value), { addSuffix: true });
      return <span>{age}</span>;
    },
  },
];

const TicketsUnAssigned = ({ loading, tickets, loadUnassignedTickets }) => {
  const navigate = useNavigate();
  const [numberOptions] = useState([5, 10, 15, 20, 25, 30]);
  const [globalFilter, setGlobalFilter] = useState("");

  useEffect(() => {
    loadUnassignedTickets();
  }, [loadUnassignedTickets]);

  const handleData = (index) => {
    const ticket = tickets[index];
    navigate("/single-ticket", { state: { ticket } });
  };

  return loading ? (
    <Spinner />
  ) : (
    <>
      <div className="flex flex-col h-screen">
        <TopBar />
        <div className="flex flex-1 overflow-hidden">
          <Sidebar />
          <main className="flex-1 p-4 overflow-y-auto">
            <div className=" mx-auto">
              <div className="flex flex-col gap-x-6 sm:flex-row sm:items-center sm:justify-end space-y-2 sm:space-y-0 sm:space-x-2 p-4">
                <div className="flex items-center border border-gray-300 rounded sm:order-1">
                  <input
                    type="text"
                    placeholder="Search"
                    className="p-2 w-full border-none outline-none"
                    value={globalFilter}
                    onChange={(e) => setGlobalFilter(e.target.value)}
                  />
                  <div className="p-2">
                    <FaSearch className="text-gray-500" />
                  </div>
                </div>
              </div>
              {tickets?.length > 0 ? (
                <Table
                  data={tickets}
                  columns={TableColumns}
                  numberOptions={numberOptions}
                  dataFun={handleData}
                  globalFilter={globalFilter}
                  setGlobalFilter={setGlobalFilter}
                />
              ) : (
                <div className="flex justify-center text-3xl font-semibold  text-neutral-600">
                  {" "}
                  No Tickets Found!
                </div>
              )}
            </div>
          </main>
        </div>
      </div>
    </>
  );
};

TicketsUnAssigned.propTypes = {
  loading: PropTypes.bool.isRequired,
  tickets: PropTypes.array,
  loadUnassignedTickets: PropTypes.func.isRequired,
};

const mapStateToProps = (state) => ({
  loading: state.tickets.loading,
  tickets: state.tickets.tickets,
});

export default connect(mapStateToProps, { loadUnassignedTickets })(
  TicketsUnAssigned
);
